<style lang="less" scoped>
  .index {
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;

    h1 {
      height: 80px;

      img {
        height: 100%;
      }
    }

    .ivu-row-flex {
      height: 100%;
    }

    .login_form {
      width: 100%;
      margin: 0 auto;
      margin-top: 20px;
    }
  }
</style>
<template>
  <div id="login">
    <div class="index bg-white"
         :style="{backgroundImage:'url(img/loginBk.jpg' + ')',backgroundRepeat:'no-repeat',backgroundSize: 'cover'}"></div>
    <div class="index tb-column tb_align-center">
      <div class="p-l-30 p-r-30" style="width:1140px;height:calc(100% - 200px)">
        <div class="tb-row tb_align-center h-100-px c-white">
          <div class="tb-row">
            <div class="f-30 tb-column-center">{{baseJson.title}}</div>
            <!-- <div class="tb-column-center m-l-8 m-r-8"><div class="bg-white" style="height:24px;width:1px"></div></div>
            <div class="f-18 tb-column-center">{{baseJson.subtitle}}</div> -->
          </div>
        </div>

        <div class="main_login tb-column-center h-100">
          <div class="tb-row w-100">
            <div class="c-white tb-column tb_align-start tb_justify-center ti-g-2 f-20">
              <div class="f-36">{{baseJson.subtitle}}</div>
              <!-- <div class="m-t-20" v-show="baseJson.showEmsFree">公章备案政务联网</div> -->
              <div class="m-t-5" v-show="baseJson.showEmsFree">实物公章、电子公章均可办理</div>
              <div class="m-t-5" v-show="baseJson.showEmsFree">快速刻章，无需多跑腿，快递免费邮寄</div>
            </div>
            <div class="ti-g-1" style="min-height:434px">
              <div class="brd-5" :style="{'background-color': 'rgba(255,255,255,0.9)'}">
                <div class="login_form">
                  <div class="tb-row h-64-px f-16 c-h">
                    <div class="ti-g-1 tb-column-center"
                         :class="{'bg-white': !loginType,'bg-gray': loginType,'c-gray-dark':!loginType,'c-gray-light':loginType}"
                         @click="loginType = 0">密码登录
                    </div>
                    <!--<div class="ti-g-1 tb-column-center"-->
                         <!--:class="{'bg-white': loginType == 1,'bg-gray': loginType != 1,'c-gray-dark':loginType == 1,'c-gray-light':loginType != 1}"-->
                         <!--@click="loginType = 1">短信验证-->
                    <!--</div>-->
                    <div class="ti-g-1 tb-column-center"
                         :class="{'bg-white': loginType == 2,'bg-gray': loginType != 2,'c-gray-dark':loginType == 2,'c-gray-light':loginType != 2}"
                         @click="loginType = 2">手机验证（免注册）
                    </div>
                  </div>
                  <div class="p-30 bg-white" style="min-height:370px">
                    <div v-show="!loginType" class="tb-column-center">
                      <Form ref="accountForm" :model="accountForm" :rules="accountFormRule">
                        <Form-item prop="regAccount">
                          <Input class="m-t-10" type="text" style="width:280px"
                                 v-model="accountForm.regAccount" placeholder="请输入手机号/邮箱">
                            <div slot="prepend" class="tb-column-center"
                                 style="height:36px;width:30px">
                              <Icon type="md-person"
                                    class="p-l-5 p-r-5 f-20 w-24-px h-24-px"></Icon>
                            </div>
                          </Input>
                        </Form-item>
                        <Form-item prop="pass">
                          <Input type="password" v-model="accountForm.pass"
                                 placeholder="请输入密码">
                            <div slot="prepend" class="tb-column-center"
                                 style="height:36px;width:30px">
                              <Icon type="md-lock" class="p-l-5 p-r-5 f-20"
                                    slot="prepend"></Icon>
                            </div>
                          </Input>
                        </Form-item>
                      </Form>
                    </div>

                    <div v-show="loginType == 1" class="tb-column-center">
                      <Form ref="mobileForm" :model="mobileForm" :rules="mobileFormRule">
                        <Form-item prop="regMobile">
                          <Input class="m-t-10" type="text" v-model="mobileForm.regMobile"
                                 placeholder="请输入手机号" style="width:280px">
                            <div slot="prepend" class="tb-column-center"
                                 style="height:36px;width:30px">
                              <Icon type="md-person"
                                    class="p-l-5 p-r-5 f-20 w-24-px h-24-px"></Icon>
                            </div>
                          </Input>
                        </Form-item>
                        <Form-item prop="kaptchaCode">
                          <div class="tb-row">
                            <Input type="text" v-model="mobileForm.kaptchaCode"
                                   @on-enter="login" placeholder="请输入图形验证码"
                                   style="width:195px">
                              <div slot="prepend" class="tb-column-center"
                                   style="height:36px;width:30px">
                                <Icon type="md-text" class="p-l-5 p-r-5 f-20"
                                      slot="prepend"></Icon>
                              </div>
                            </Input>
                            <div class="c-h m-l-5" @click="reCode"
                                 style="height:30px;margin-top:2px">
                              <img :src="url + uuid" height="32px"
                                   class="brd-5 w-80-px h-44-px">
                            </div>
                          </div>
                        </Form-item>
                        <Form-item prop="smsCode" class="smsCheck">
                          <div class="tb-row">
                            <Input type="text" v-model="mobileForm.smsCode"
                                   placeholder="请输入验证码" style="width:195px">
                              <div slot="prepend" class="tb-column-center"
                                   style="height:36px;width:30px">
                                <Icon type="md-lock" class="p-l-5 p-r-5 f-20"
                                      slot="prepend"></Icon>
                              </div>
                            </Input>
                            <Button type="primary" ghost
                                    class="m-l-5 w-80-px tb-column-center"
                                    style="margin-top:2px" @click="sendSms"
                                    :disabled="countDown.disable">{{countDown.text}}
                            </Button>
                          </div>
                        </Form-item>
                      </Form>
                    </div>

                    <div v-show="loginType == 2" class="tb-column-center">
                      <Form ref="regForm" :model="mobileForm" :rules="mobileFormRule">
                        <Form-item prop="regMobile">
                          <Input class="m-t-10" type="text" v-model="mobileForm.regMobile"
                                 placeholder="请输入手机号" style="width:280px">
                            <div slot="prepend" class="tb-column-center"
                                 style="height:36px;width:30px">
                              <Icon type="md-person"
                                    class="p-l-5 p-r-5 f-20 w-24-px h-24-px"></Icon>
                            </div>
                          </Input>
                        </Form-item>
                        <Form-item prop="kaptchaCode">
                          <div class="tb-row">
                            <Input type="text" v-model="mobileForm.kaptchaCode"
                                   @on-enter="login" placeholder="请输入图形验证码"
                                   style="width:195px">
                              <div slot="prepend" class="tb-column-center"
                                   style="height:36px;width:30px">
                                <Icon type="md-text" class="p-l-5 p-r-5 f-20"
                                      slot="prepend"></Icon>
                              </div>
                            </Input>
                            <div class="c-h m-l-5" @click="reCode"
                                 style="height:30px;margin-top:2px">
                              <img :src="url + uuid" height="32px"
                                   class="brd-5 w-80-px h-44-px">
                            </div>
                          </div>
                        </Form-item>
                        <Form-item prop="smsCode" class="smsCheck">
                          <div class="tb-row">
                            <Input type="text" v-model="mobileForm.smsCode"
                                   placeholder="请输入验证码" style="width:195px">
                              <div slot="prepend" class="tb-column-center"
                                   style="height:36px;width:30px">
                                <Icon type="md-lock" class="p-l-5 p-r-5 f-20"
                                      slot="prepend"></Icon>
                              </div>
                            </Input>
                            <Button type="primary" ghost class="m-l-5" @click="sendSms"
                                    :disabled="countDown.disable">{{countDown.text}}
                            </Button>
                          </div>
                        </Form-item>
                      </Form>
                    </div>

                    <Form>
                      <Form-item class="m-t-20">
                        <div class="tb-column-center">
                          <Button type="primary" class="f-18" style="width:280px;height:46px" @click="login">登&nbsp;&nbsp;录</Button>
                        </div>
                      </Form-item>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tb-column-center h-100-px c-gray-4">
          <div class="tb-column">
            <a class="m-r-10 c-gray-4" target="_blank"
               href="http://www.miitbeian.gov.cn/">{{baseJson.icp}}</a>{{baseJson.origin}}
            {{baseJson.certNo}}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import md5 from 'md5'
  import {mapState} from 'vuex'
  import {api, util} from "@/libs"

  export default {
    data() {
      const height = window.innerHeight - 200 > 340 ? 340 : window.innerHeight - 220
      return {
        loginType: 0,
        uuid: util.uuid(),
        url: api.url + api.libThird.kaptcha,
        config: {
          index: 0,
          height: height,
          title: 'client.title',
          arr: [{
            style: {
              'background-image': "url('static/client/user_center/login/1.jpg')"
            },
            name: '1'
          }, {
            style: {
              'background-image': "url('static/client/user_center/login/2.jpg')"
            },
            name: '2'
          }, {
            style: {
              'background-image': "url('static/client/user_center/login/3.jpg')"
            },
            name: '3'
          }]
        },
        accountForm: {
          regAccount: '',
          pass: '',
        },
        mobileForm: {
          regMobile: '',
          smsCode: '',
          kaptchaCode: ''
        },
        accountFormRule: {
          regAccount: [{
            required: true,
            trigger: 'blur',
            message: '请输入手机号/邮箱'
          }],
          pass: [{
            required: true,
            trigger: 'blur',
            message: '请输入密码'
          }],
        },
        mobileFormRule: {
          regMobile: [{
            required: true,
            trigger: 'blur',
            message: '请输入正确的手机号'
          }],
          smsCode: [{
            required: true,
            trigger: 'blur',
            message: '请输入正确的验证码'
          }],
          kaptchaCode: [{
            required: true,
            trigger: "blur",
            message: "请输入图形验证码"
          }]
        }
      }
    },
    computed: {
      ...mapState({
        countDown: state => state.main.countDown,
        baseJson: state => state.main.config.baseJson
      })
    },
    methods: {
      loginSuccess(res) {
        this.$router.addRoutes(this.$store.state.custom.routers)
        this.$router.push({path: this.$route.query.redirect || '/custom/center'})
      },
      login() {
        if (this.loginType === 0) {
          this.$refs.accountForm.validate(valid => {
            if (valid) {
              this.$store.dispatch('custom/loginClientRegName', {
                regAccount: this.accountForm.regAccount,
                regMd5Pass: md5(this.accountForm.pass)
              }).then(this.loginSuccess)
            }
          })
        } else {
          const form = this.loginType === 1 ? this.$refs.mobileForm : this.$refs.regForm
          form.validate(valid => {
            if (valid) {
              this.$store.dispatch('custom/loginClientSmsCode', {
                regMobile: this.mobileForm.regMobile,
                smsCode: this.mobileForm.smsCode,
                autoCreate: this.loginType === 2
              }).then(this.loginSuccess)
            }
          })
        }
      },
      reCode() {
        this.uuid = util.uuid();
      },
      sendSms() {
        if (this.mobileForm.regMobile) {
          this.$store.dispatch('main/thirdSmsCodeSendKaptcha', {
            mobile: this.mobileForm.regMobile,
            uuid: this.uuid,
            code: this.mobileForm.kaptchaCode
          })
            .then(() => this.reCode(), () => this.reCode())
        }
      }
    }
  }
</script>

<style lang="less">
  #login {
    input {
      height: 46px;
    }
  }
</style>